'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:selectRoundDate');
}

var _invoke = require('../invoke');

/**
 * 选择日期
 *
 * @memberof flight
 * @static
 * @name selectRoundDate
 * @return {Promise}
 * @example
 *  hbnb.flight.selectRoundDate().then(function(data) {
 *      console.log(data);
 *  });
 */
module.exports = function() {
    var p = new Promise(function(resolve, reject) {
        _invoke('flight', 'select_roundDate', {
            callback: function(date) {
                resolve(date);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/flight/select-round-date.js
// module id = 309
// module chunks = 0